import { useMutation } from '@tanstack/react-query';
import { POST, POST_SEND_LINE_MSG } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const useSendLineMsg = ({ onSuccessCallBack }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_SEND_LINE_MSG(), payload);
      onSuccessCallBack && onSuccessCallBack(response);
      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'ส่งข้อความสำเร็จ',
      });
    },
  });
  return { mutate, loading: isPending };
};
